// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmn-literal-expression-container {
  --decision-properties-background-color: var(--color-white);
  --decision-properties-border-color: var(--color-grey-225-10-15);
  --decision-properties-color: var(--color-grey-225-10-15);
  --literal-expression-color: var(--color-grey-225-10-15);
  --literal-expression-properties-border-color: var(--color-grey-225-10-15);
  --literal-expression-properties-color: var(--color-grey-225-10-15);
  --powered-by-overlay-background-color: var(--color-black-opacity-20);
  --powered-by-overlay-content-background-color: var(--color-white);
  --powered-by-overlay-content-border-color: var(--color-grey-225-10-75);
  --powered-by-overlay-content-color: var(--color-grey-225-10-15);
  --textarea-border-color: var(--color-grey-225-10-15);
  --textarea-color: var(--color-grey-225-10-15);
  --view-drd-button-background-color: var(--color-white);
  --view-drd-button-border-color: var(--color-grey-225-10-75);
  --view-drd-button-color: var(--color-grey-225-10-15);
  --view-drd-button-hover-background-color: var(--color-grey-225-10-97);
  --literal-expression-font-family: 'Arial', sans-serif;
  --literal-expression-font-family-monospace: monospace;

  font-family: var(--literal-expression-font-family);
  color: var(--literal-expression-color);
  width: 100%;
  height: 100%;
}

.dmn-literal-expression-container .viewer-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.dmn-literal-expression-container * {
  box-sizing: border-box;
}

/* decision properties */
.dmn-literal-expression-container .decision-properties {
  border: 1px solid var(--decision-properties-border-color);
  border-bottom: none;
  padding: 10px;
  padding-right: 75px;
  color: var(--decision-properties-color);
  background-color: var(--decision-properties-background-color);
  position: relative;
  min-width: 192px;
}

.dmn-literal-expression-container .decision-name {
  margin: 0;
  font-size: 21px;
  font-weight: normal;
  white-space: pre;
}

.dmn-literal-expression-container .decision-name:not(.editor) {
  cursor: default;
}

.dmn-literal-expression-container .decision-name.editor {
  cursor: text;
}

.dmn-literal-expression-container .decision-name div {
  outline: none;
}

.dmn-literal-expression-container .decision-name:not(.editable),
.dmn-literal-expression-container .decision-name [contenteditable="true"] {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.dmn-literal-expression-container .textarea .content-editable {
  height: 100%;
  box-sizing: border-box;
}

.dmn-literal-expression-container .decision-name.editor:not(.focussed):hover {
  cursor: text;
}

.dmn-literal-expression-container .decision-name.focussed .content-editable {
  text-overflow: unset;
}

/* textarea */
.dmn-literal-expression-container .textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  font-family: var(--literal-expression-font-family-monospace);
  line-height: 1.4;
  border: 1px solid var(--textarea-border-color);
  border-bottom-width: 1px;
  white-space: pre;
  font-size: 14px;
  color: var(--textarea-color);
  min-height: 250px;
  overflow: auto;
}

.dmn-literal-expression-container .textarea div:focus {
  outline: none;
}

.dmn-literal-expression-container .textarea.editor {
  cursor: text;
}

.dmn-literal-expression-container .textarea:not(.editor) {
  cursor: default;
}

/* literal expression properties */
.dmn-literal-expression-container .literal-expression-properties {
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  border: 1px solid var(--literal-expression-properties-border-color);
  border-top: none;
  font-size: 14px;
  color: var(--literal-expression-properties-color);
}

.dmn-literal-expression-container .literal-expression-properties .variables-table {
  border-spacing: 8px;
  border-collapse: separate;
}

.dmn-literal-expression-container .literal-expression-properties .variables-table tr td:first-child {
  font-weight: bold;
}

.dmn-literal-expression-container .literal-expression-properties .variables-table tr td:last-child {
  min-width: 100px;
}

.dmn-literal-expression-container .literal-expression-properties .variable-name-input {
  width: 100%;
}

/* view drd */
.dmn-literal-expression-container .view-drd {
  margin-right: 10px;
  padding-bottom: 10px;
}

.dmn-literal-expression-container .view-drd .view-drd-button {
  background: var(--view-drd-button-background-color);
  padding: 8px;
  border: solid 1px var(--view-drd-button-border-color);
  border-radius: 2px;
  font-size: 14px;
  color: var(--view-drd-button-color);
  font-weight: bold;
  cursor: pointer;
}

.dmn-literal-expression-container .view-drd .view-drd-button:hover {
  background: var(--view-drd-button-hover-background-color);
}
`, "",{"version":3,"sources":["webpack://./node_modules/dmn-js/dist/assets/dmn-js-literal-expression.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,+DAA+D;EAC/D,wDAAwD;EACxD,uDAAuD;EACvD,yEAAyE;EACzE,kEAAkE;EAClE,oEAAoE;EACpE,iEAAiE;EACjE,sEAAsE;EACtE,+DAA+D;EAC/D,oDAAoD;EACpD,6CAA6C;EAC7C,sDAAsD;EACtD,2DAA2D;EAC3D,oDAAoD;EACpD,qEAAqE;EACrE,qDAAqD;EACrD,qDAAqD;;EAErD,kDAAkD;EAClD,sCAAsC;EACtC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,yDAAyD;EACzD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,gBAAgB;EAChB,8CAA8C;EAC9C,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,mEAAmE;EACnE,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D","sourcesContent":[".dmn-literal-expression-container {\r\n  --decision-properties-background-color: var(--color-white);\r\n  --decision-properties-border-color: var(--color-grey-225-10-15);\r\n  --decision-properties-color: var(--color-grey-225-10-15);\r\n  --literal-expression-color: var(--color-grey-225-10-15);\r\n  --literal-expression-properties-border-color: var(--color-grey-225-10-15);\r\n  --literal-expression-properties-color: var(--color-grey-225-10-15);\r\n  --powered-by-overlay-background-color: var(--color-black-opacity-20);\r\n  --powered-by-overlay-content-background-color: var(--color-white);\r\n  --powered-by-overlay-content-border-color: var(--color-grey-225-10-75);\r\n  --powered-by-overlay-content-color: var(--color-grey-225-10-15);\r\n  --textarea-border-color: var(--color-grey-225-10-15);\r\n  --textarea-color: var(--color-grey-225-10-15);\r\n  --view-drd-button-background-color: var(--color-white);\r\n  --view-drd-button-border-color: var(--color-grey-225-10-75);\r\n  --view-drd-button-color: var(--color-grey-225-10-15);\r\n  --view-drd-button-hover-background-color: var(--color-grey-225-10-97);\r\n  --literal-expression-font-family: 'Arial', sans-serif;\r\n  --literal-expression-font-family-monospace: monospace;\r\n\r\n  font-family: var(--literal-expression-font-family);\r\n  color: var(--literal-expression-color);\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.dmn-literal-expression-container .viewer-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.dmn-literal-expression-container * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* decision properties */\r\n.dmn-literal-expression-container .decision-properties {\r\n  border: 1px solid var(--decision-properties-border-color);\r\n  border-bottom: none;\r\n  padding: 10px;\r\n  padding-right: 75px;\r\n  color: var(--decision-properties-color);\r\n  background-color: var(--decision-properties-background-color);\r\n  position: relative;\r\n  min-width: 192px;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name {\r\n  margin: 0;\r\n  font-size: 21px;\r\n  font-weight: normal;\r\n  white-space: pre;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name:not(.editor) {\r\n  cursor: default;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name.editor {\r\n  cursor: text;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name div {\r\n  outline: none;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name:not(.editable),\r\n.dmn-literal-expression-container .decision-name [contenteditable=\"true\"] {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.dmn-literal-expression-container .textarea .content-editable {\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name.editor:not(.focussed):hover {\r\n  cursor: text;\r\n}\r\n\r\n.dmn-literal-expression-container .decision-name.focussed .content-editable {\r\n  text-overflow: unset;\r\n}\r\n\r\n/* textarea */\r\n.dmn-literal-expression-container .textarea {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  padding: 12px;\r\n  font-family: var(--literal-expression-font-family-monospace);\r\n  line-height: 1.4;\r\n  border: 1px solid var(--textarea-border-color);\r\n  border-bottom-width: 1px;\r\n  white-space: pre;\r\n  font-size: 14px;\r\n  color: var(--textarea-color);\r\n  min-height: 250px;\r\n  overflow: auto;\r\n}\r\n\r\n.dmn-literal-expression-container .textarea div:focus {\r\n  outline: none;\r\n}\r\n\r\n.dmn-literal-expression-container .textarea.editor {\r\n  cursor: text;\r\n}\r\n\r\n.dmn-literal-expression-container .textarea:not(.editor) {\r\n  cursor: default;\r\n}\r\n\r\n/* literal expression properties */\r\n.dmn-literal-expression-container .literal-expression-properties {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  padding: 0;\r\n  border: 1px solid var(--literal-expression-properties-border-color);\r\n  border-top: none;\r\n  font-size: 14px;\r\n  color: var(--literal-expression-properties-color);\r\n}\r\n\r\n.dmn-literal-expression-container .literal-expression-properties .variables-table {\r\n  border-spacing: 8px;\r\n  border-collapse: separate;\r\n}\r\n\r\n.dmn-literal-expression-container .literal-expression-properties .variables-table tr td:first-child {\r\n  font-weight: bold;\r\n}\r\n\r\n.dmn-literal-expression-container .literal-expression-properties .variables-table tr td:last-child {\r\n  min-width: 100px;\r\n}\r\n\r\n.dmn-literal-expression-container .literal-expression-properties .variable-name-input {\r\n  width: 100%;\r\n}\r\n\r\n/* view drd */\r\n.dmn-literal-expression-container .view-drd {\r\n  margin-right: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.dmn-literal-expression-container .view-drd .view-drd-button {\r\n  background: var(--view-drd-button-background-color);\r\n  padding: 8px;\r\n  border: solid 1px var(--view-drd-button-border-color);\r\n  border-radius: 2px;\r\n  font-size: 14px;\r\n  color: var(--view-drd-button-color);\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.dmn-literal-expression-container .view-drd .view-drd-button:hover {\r\n  background: var(--view-drd-button-hover-background-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
